<template>
  <div>
    <el-row>
      <el-col :span="2" style="font-size:28px; text-align: center; padding-top: 19px">
        <el-tooltip
          class="item"
          effect="dark"
          content="返回上一级页面"
          placement="bottom-start"
          :disabled="showTooltip"
        >
          <i class="el-icon-arrow-left" @click="onBack" style="cursor: pointer"></i>
        </el-tooltip>
      </el-col>
      <el-col :span="12">
        <h3>
          <span v-show="!create">修改开票点开票员</span>
          <span v-show="create">新增开票点开票员</span>
        </h3>
      </el-col>
    </el-row>
    <div style="margin: 8px 40px 40px; border-bottom: 1px solid #CCC"></div>
    <div style="max-width: 800px">
      <el-form
        ref="form"
        :model="form"
        :rules="formRules"
        label-width="180px"
        v-loading="showLoading"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="票据种类名称" prop="einvoiceTypeCode">
              <span v-if="!create">{{this.form.einvoiceTypeName}}</span>
              <el-select
                v-if="create"
                placeholder="请选择票据种类"
                v-model="form.einvoiceTypeCode"
                style="width:100%;"
              >
                <el-option
                  v-for="item in einvoiceTypeOptions"
                  :key="item.einvoiceTypeCode"
                  :label="item.einvoiceTypeName+'|'+item.einvoiceTypeCode"
                  :value="item.einvoiceTypeCode"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="开票员选择" prop="type">
              <el-input v-model="form.userNameLabel" placeholder="选择开票员" clearable readonly="readonly" 
                  @click.native="onUserClick()"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-dialog
            title="选择开票员"
            :append-to-body="true"
            :width="'400px'"
            :visible.sync="view.showUser">
            <User @chose="userChose"></User>
        </el-dialog>
        <el-form-item>
          <el-button type="primary" size="small" @click="onSave" v-loading="showBtnLoading">确定</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import User from "./User.vue"

let _kits, _form;
export default {
  props: ["entity"],
  components: {
      User
  },
  data() {
    let create = this.entity.creat;
    let form = {
      agencyName: this.entity.agencyName,
      agencyCode: this.entity.agencyCode,
      placeCode: this.entity.placeCode,
      placeName: this.entity.placeName,
      einvoiceTypeCode: "",
      einvoiceTypeName: "",
      userCode: ""
    };
    let data = {
      view: {
        showUser: false
      },
      userVarCodeName: "",
      userVarLabelName: "",
      showLoading: true,
      showTooltip: false,
      showBtnLoading: false,
      create,
      form,
      formRules: {
        einvoiceTypeCode: [
          {
            required: true,
            message: "请选择开票员种类",
            trigger: "blur"
          }
        ],
        uerName: [
          {
            required: true,
            message: "请选择开票员",
            trigger: "blur"
          }
        ]
      },
      agencyTypeOptions: [],
      einvoiceGxmsOptions: [],
      einvoiceTypeOptions: []
    };
    return data;
  },
  methods: {
    onUserClick() {
        this.view.showUser = true;
    },
    userChose(data) {
        this.view.showUser = false;
        this.userVarCodeName = "";
        this.userVarLabelName = "";
        for(var i=0; i<data.length; i++){
          if(i==data.length-1){
            this.userVarCodeName = this.userVarCodeName + data[i].id;
            this.userVarLabelName = this.userVarLabelName + data[i].label;
          }else{
            this.userVarCodeName = this.userVarCodeName + data[i].id + ",";
            this.userVarLabelName = this.userVarLabelName + data[i].label + ",";
          }
        }
        this.form.userCode= this.userVarCodeName;
        this.form.userNameLabel = this.userVarLabelName;
    },
    onBack() {
      this.$emit("back");
    },
    onSave() {
      _form.submit();
    },
  },
  created() {
    _kits = this.$kits();
    _kits.api.call(
      "QUERYAGENCYPLACEEINVOICETYPECODE",
      {
        agencyCode: this.form.agencyCode,
        placeCode: this.form.placeCode
      },
      result => {
        if (result.returnCode == "0000") {
          let data = result.data;
          this.einvoiceTypeOptions = data;
          this.form.einvoiceTypeCode = data[0].einvoiceTypeCode;
        } else {
          this.$message.error(result.returnMsg);
        }
      }
    );
  },
  mounted() {
    _form = _kits.control.getStandardForm({
      name: "form",
      api: "SAVEAGENCYPLACEUSER"
    });
    setTimeout(() => {
      _kits.page.foucus("ipt01");
      this.showLoading = false;
      this.showTooltip = true;
    }, 300);
  }
};
</script>
